<template>
  <div class="home">
    <v-e24-nav-bar/>
	<section id="page-not-found" class="m-t-80 p-b-150">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <div class="page-error-404">404</div>
                    </div>
                    <div class="col">
                        <div class="text-left">
                            <h1 class="text-medium">Ooops, This Page Could Not Be Found!</h1>
                            <p class="lead">The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    <v-e24-footer />
  </div>
</template>

<script>
import headerImageFull from '@/components/home/HeaderImageFull'

export default {
	name: 'Error404',
	components: {
		headerImageFull
	}
}
</script>



// WEBPACK FOOTER //
// src/views/Error404.vue